import React from "react";
import { Eraser, CircleNotch } from "@phosphor-icons/react";

/**
 * WizardClearButton — az F3 (AgentInputScreen) accent-színű "Törlés" pill
 * KÖZVETLEN másolata. Az első kérdés sorába való (jobbra igazítva).
 * A `accent` prop-pal illeszkedik az adott layer szín-identitásához.
 * A `onClick` callback csak a szülő lokális form-state-jét ürítse.
 */
export function WizardClearButton({
  onClick,
  clearing = false,
  accent = "#5e50f7",
  testid = "wizard-clear-btn",
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={clearing}
      data-testid={testid}
      title="Válaszok törlése"
      aria-label="Válaszok törlése"
      className="shrink-0 inline-flex items-center gap-1.5 transition"
      style={{
        background: `${accent}14`,
        border: `1px solid ${accent}40`,
        color: accent,
        cursor: clearing ? "wait" : "pointer",
        padding: "5px 11px",
        borderRadius: 999,
        fontSize: 10.5,
        fontWeight: 600,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        lineHeight: 1,
        marginTop: -2,
      }}
      onMouseEnter={(e) => {
        if (clearing) return;
        e.currentTarget.style.background = `${accent}22`;
        e.currentTarget.style.borderColor = `${accent}66`;
      }}
      onMouseLeave={(e) => {
        if (clearing) return;
        e.currentTarget.style.background = `${accent}14`;
        e.currentTarget.style.borderColor = `${accent}40`;
      }}
    >
      {clearing ? (
        <CircleNotch size={11} weight="bold" className="mex-spin" />
      ) : (
        <Eraser size={11} weight="bold" />
      )}
      Törlés
    </button>
  );
}
